<template>
  <svg
    :class="['star-rating-star']"
    :height="starSize"
    :width="starSize"
    :viewBox="viewBox"
    @mousemove="mouseMoving"
    @click="selected"
    @touchstart="touchStart"
    @touchend="touchEnd"
  >
    <polygon :points="starPointsToString" :fill="fill" />
  </svg>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    starId: number
    fill: string
    starSize?: number
  }>(),
  { starSize: 40 },
)

const emit = defineEmits(['star-mouse-move', 'selected'])

const starPoints: Ref<number[]> = ref([
  19.8, 2.2, 6.6, 43.56, 39.6, 17.16, 0, 17.16, 33, 43.56,
])

const starPointsToString = computed<string>(() => {
  return starPoints.value.join(',')
})

const maxSize = computed(() =>
  starPoints.value.reduce(function (a, b) {
    return Math.max(a, b)
  }),
)

const viewBox = computed(() => '0 0 ' + maxSize.value + ' ' + maxSize.value)

function selected() {
  emit('selected', { id: props.starId })
}

function mouseMoving(event) {
  emit('star-mouse-move', {
    event,
    // position: getPosition(event),
    id: props.starId,
  })
}
</script>

<style scoped>
.star-rating-star {
  overflow: visible !important;
}
</style>
